import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import uploadProgress from '../components/upload-progress.vue';
import { postOtaUpload } from '@blade-sxp/ota-management/api/index';
import { getFileSize } from '@blade/common/utils/file';
let default_1 = class extends Vue {
    stepActive = 1;
    form = {
        fileName: '',
        fileVision: '',
        md5: '',
        type: 'FIRMWARE',
    };
    fileName = '';
    fileSize = 0;
    uploadCompleted = false;
    uploadRules = {
        fileName: { required: true, message: this.$t('selectUpdatePackage'), trigger: 'change' },
        fileVision: [{ required: true, message: this.$t('common.pleaseInput'), trigger: 'change' }],
    };
    originFile = null;
    getFileSize = getFileSize;
    handleChange(file) {
        const name = file.name;
        this.form.fileName = name;
        this.fileSize = file.size;
        this.originFile = file.raw;
        return false;
    }
    handleSubmit() {
        const { fileName } = this.form;
        const reg = /[^a-zA-Z\d/!-_.*'()]+/;
        if (reg.test(fileName)) {
            this.$elmessage.warning(this.$t('specialTips').toString());
        }
        else {
            this.$refs['upload-form'].validate((valid) => {
                if (valid) {
                    if (!fileName.endsWith('.tar')) {
                        this.$elmessage.warning(this.$t('tarError').toString());
                    }
                    else {
                        this.stepActive = 2;
                    }
                }
            });
        }
    }
    mounted() { }
    goBack() {
        localStorage.setItem('activeIndex', '2');
        this.$router.back();
    }
    onUploadCanceled() {
        this.stepActive = 1;
        this.form.md5 = '';
    }
    uploadPackage() {
        const { fileVision, md5, fileName } = this.form;
        return postOtaUpload({
            md5,
            name: fileName,
            size: this.fileSize,
            url: '',
            type: 'FIRMWARE',
            version: `v${fileVision}`,
        }).then(() => {
            this.uploadCompleted = true;
        });
    }
};
default_1 = __decorate([
    Component({
        name: 'OtaUploadEdit',
        components: { uploadProgress },
        i18n: {
            messages: {
                'en-us': {
                    guide: 'Upload Guide',
                    SelectFile: 'Select update package file ',
                    select: 'Select',
                    nextStep: 'Next Step',
                    fileName: 'File Name',
                    type: 'type',
                    version: 'Version',
                    size: 'Size',
                    selectUpdatePackage: 'Please select the update package!',
                    enterMD5: 'Please enter the MD5!',
                    complete: 'Submit',
                    conformSpecification: 'Your uploaded file does not conform to the specification, please choose again.',
                    step1: 'Select Update Package',
                    step2: 'Upload & Verify',
                    versionError: 'Version number is different from that in the file name',
                    tarError: 'Please upload the file with suffix tar',
                    specialTips: 'File name can only use alphanumeric characters and special characters',
                },
                zh: {
                    guide: '上传指引',
                    SelectFile: '选择文件',
                    select: '选择',
                    nextStep: '下一步',
                    fileName: '文件名',
                    type: '类型',
                    version: '版本号',
                    size: '大小',
                    selectUpdatePackage: '请选择更新包!',
                    enterMD5: '请输入MD5!',
                    complete: '完成',
                    conformSpecification: '您的上传文件不符合规范，请重新选择。',
                    step1: '选择更新包',
                    step2: '上传&校验',
                    versionError: '版本号与文件名中版本号不同',
                    tarError: '请上传后缀为 .tar 的更新包',
                    specialTips: '更新包名称只允许使用英文字母、数字和特殊字符',
                },
            },
        },
    })
], default_1);
export default default_1;
